const ADD_CHARACTER_WIDTHS = `characterWidthMap:ADD_CHARACTER_WIDTHS`;

export const actionTypes = {
  ADD_CHARACTER_WIDTHS
};

const addCharacterWidths = widthMap => {
  return {
    type: ADD_CHARACTER_WIDTHS,
    widthMap
  };
};

export default {
  addCharacterWidths
};
